import React from 'react'
import clsx from 'clsx'
import {KTSVG} from '../../../helpers'

type Props = {
  title: string
  icon?: string
  fontIcon?: string
  hasArrow?: boolean
  hasBullet?: boolean
}

const MenuItem: React.FC<Props> = ({
  title,
  icon,
  fontIcon,
  hasArrow = false,
  hasBullet = false,
}) => {

  return (
    <div className='menu-item me-lg-1'>
      <div
        className={'py-3'}
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}

        {icon && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}

        {fontIcon && (
          <span className='menu-icon'>
            <i className={clsx('bi fs-3', fontIcon)}></i>
          </span>
        )}

        <span className='fs-5'>{title}</span>

        {hasArrow && <span className='menu-arrow'></span>}
      </div>
    </div>
  )
}

export {MenuItem}
